const legalDocumentActionTranslations = {
  en: {
    download: "Download",
    controlledGeneration: "Controlled document generation",
    noApprovedTemplate: "No approved template matches this document type and language.",
    generatePdf: "Generate PDF",
    generateDocx: "Generate DOCX",
    generated: "Document generated successfully",
    uploadVersion: "Upload version",
    versionUploaded: "Document version uploaded",
    submitReview: "Submit for legal review",
    submittedForReview: "Submitted for legal review",
    legalReview: "Legal review",
    reviewApproved: "Legal review approved",
    changesRequested: "Changes requested",
    reviewerName: "Qualified reviewer name",
    reviewerCapacity: "Professional capacity",
    reviewerRegistration: "Professional registration reference",
    reviewNotes: "Legal review notes",
    confirmReview: "I confirm that the identified qualified professional reviewed this exact document version.",
    recordDecision: "Record decision",
    recordSignedOriginal: "Record signed original",
    signatureNotes: "Signature notes",
    signedWarning: "The signed PDF will be stored as an immutable original and cannot be replaced.",
    selectSignedPdf: "Select the signed PDF first",
    storeAndLock: "Store and lock signed original",
    signedOriginalStored: "Signed original stored and locked",
  },
  pt: {
    download: "Descarregar",
    controlledGeneration: "Geração controlada de documentos",
    noApprovedTemplate: "Não existe um modelo aprovado para este tipo de documento e idioma.",
    generatePdf: "Gerar PDF",
    generateDocx: "Gerar DOCX",
    generated: "Documento gerado com sucesso",
    uploadVersion: "Carregar versão",
    versionUploaded: "Versão do documento carregada",
    submitReview: "Submeter para revisão jurídica",
    submittedForReview: "Submetido para revisão jurídica",
    legalReview: "Revisão jurídica",
    reviewApproved: "Revisão jurídica aprovada",
    changesRequested: "Alterações solicitadas",
    reviewerName: "Nome do profissional jurídico qualificado",
    reviewerCapacity: "Qualidade profissional",
    reviewerRegistration: "Referência de inscrição profissional",
    reviewNotes: "Notas da revisão jurídica",
    confirmReview: "Confirmo que o profissional qualificado identificado reviu esta versão exata do documento.",
    recordDecision: "Registar decisão",
    recordSignedOriginal: "Registar original assinado",
    signatureNotes: "Notas relativas à assinatura",
    signedWarning: "O PDF assinado será conservado como original imutável e não poderá ser substituído.",
    selectSignedPdf: "Selecione primeiro o PDF assinado",
    storeAndLock: "Guardar e bloquear o original assinado",
    signedOriginalStored: "Original assinado guardado e bloqueado",
  },
  zh: {
    download: "下载",
    controlledGeneration: "受控文件生成",
    noApprovedTemplate: "没有与此文件类型和语言匹配的已批准模板。",
    generatePdf: "生成 PDF",
    generateDocx: "生成 DOCX",
    generated: "文件生成成功",
    uploadVersion: "上传版本",
    versionUploaded: "文件版本已上传",
    submitReview: "提交法律审核",
    submittedForReview: "已提交法律审核",
    legalReview: "法律审核",
    reviewApproved: "法律审核已批准",
    changesRequested: "已要求修改",
    reviewerName: "合资格审核人员姓名",
    reviewerCapacity: "专业身份",
    reviewerRegistration: "专业注册编号",
    reviewNotes: "法律审核备注",
    confirmReview: "本人确认上述合资格专业人士已审核本文件的这一确切版本。",
    recordDecision: "记录决定",
    recordSignedOriginal: "登记已签署原件",
    signatureNotes: "签署备注",
    signedWarning: "已签署的 PDF 将作为不可更改的原件保存，且不得替换。",
    selectSignedPdf: "请先选择已签署的 PDF",
    storeAndLock: "保存并锁定已签署原件",
    signedOriginalStored: "已签署原件已保存并锁定",
  },
  fr: {
    download: "Télécharger",
    controlledGeneration: "Génération contrôlée de documents",
    noApprovedTemplate: "Aucun modèle approuvé ne correspond à ce type de document et à cette langue.",
    generatePdf: "Générer le PDF",
    generateDocx: "Générer le DOCX",
    generated: "Document généré avec succès",
    uploadVersion: "Téléverser une version",
    versionUploaded: "Version du document téléversée",
    submitReview: "Soumettre à la révision juridique",
    submittedForReview: "Soumis à la révision juridique",
    legalReview: "Révision juridique",
    reviewApproved: "Révision juridique approuvée",
    changesRequested: "Modifications demandées",
    reviewerName: "Nom du professionnel juridique qualifié",
    reviewerCapacity: "Qualité professionnelle",
    reviewerRegistration: "Référence d’inscription professionnelle",
    reviewNotes: "Notes de révision juridique",
    confirmReview: "Je confirme que le professionnel qualifié identifié a examiné cette version exacte du document.",
    recordDecision: "Enregistrer la décision",
    recordSignedOriginal: "Enregistrer l’original signé",
    signatureNotes: "Notes relatives à la signature",
    signedWarning: "Le PDF signé sera conservé comme original immuable et ne pourra pas être remplacé.",
    selectSignedPdf: "Sélectionnez d’abord le PDF signé",
    storeAndLock: "Conserver et verrouiller l’original signé",
    signedOriginalStored: "Original signé conservé et verrouillé",
  },
  es: {
    download: "Descargar",
    controlledGeneration: "Generación controlada de documentos",
    noApprovedTemplate: "No existe una plantilla aprobada para este tipo de documento e idioma.",
    generatePdf: "Generar PDF",
    generateDocx: "Generar DOCX",
    generated: "Documento generado correctamente",
    uploadVersion: "Cargar versión",
    versionUploaded: "Versión del documento cargada",
    submitReview: "Enviar a revisión jurídica",
    submittedForReview: "Enviado a revisión jurídica",
    legalReview: "Revisión jurídica",
    reviewApproved: "Revisión jurídica aprobada",
    changesRequested: "Cambios solicitados",
    reviewerName: "Nombre del profesional jurídico cualificado",
    reviewerCapacity: "Capacidad profesional",
    reviewerRegistration: "Referencia de colegiación profesional",
    reviewNotes: "Notas de la revisión jurídica",
    confirmReview: "Confirmo que el profesional cualificado identificado revisó esta versión exacta del documento.",
    recordDecision: "Registrar decisión",
    recordSignedOriginal: "Registrar original firmado",
    signatureNotes: "Notas sobre la firma",
    signedWarning: "El PDF firmado se conservará como original inmutable y no podrá sustituirse.",
    selectSignedPdf: "Seleccione primero el PDF firmado",
    storeAndLock: "Guardar y bloquear el original firmado",
    signedOriginalStored: "Original firmado guardado y bloqueado",
  },
  de: {
    download: "Herunterladen",
    controlledGeneration: "Kontrollierte Dokumentenerstellung",
    noApprovedTemplate: "Für diesen Dokumenttyp und diese Sprache ist keine genehmigte Vorlage vorhanden.",
    generatePdf: "PDF erstellen",
    generateDocx: "DOCX erstellen",
    generated: "Dokument erfolgreich erstellt",
    uploadVersion: "Version hochladen",
    versionUploaded: "Dokumentversion hochgeladen",
    submitReview: "Zur rechtlichen Prüfung einreichen",
    submittedForReview: "Zur rechtlichen Prüfung eingereicht",
    legalReview: "Rechtliche Prüfung",
    reviewApproved: "Rechtliche Prüfung genehmigt",
    changesRequested: "Änderungen angefordert",
    reviewerName: "Name des qualifizierten Rechtsprüfers",
    reviewerCapacity: "Berufliche Funktion",
    reviewerRegistration: "Berufliche Registrierungsnummer",
    reviewNotes: "Anmerkungen zur rechtlichen Prüfung",
    confirmReview: "Ich bestätige, dass der angegebene qualifizierte Fachmann genau diese Dokumentversion geprüft hat.",
    recordDecision: "Entscheidung erfassen",
    recordSignedOriginal: "Unterzeichnetes Original erfassen",
    signatureNotes: "Anmerkungen zur Unterzeichnung",
    signedWarning: "Das unterzeichnete PDF wird als unveränderliches Original gespeichert und kann nicht ersetzt werden.",
    selectSignedPdf: "Wählen Sie zuerst das unterzeichnete PDF aus",
    storeAndLock: "Unterzeichnetes Original speichern und sperren",
    signedOriginalStored: "Unterzeichnetes Original gespeichert und gesperrt",
  },
  it: {
    download: "Scarica",
    controlledGeneration: "Generazione controllata dei documenti",
    noApprovedTemplate: "Non esiste un modello approvato per questo tipo di documento e questa lingua.",
    generatePdf: "Genera PDF",
    generateDocx: "Genera DOCX",
    generated: "Documento generato correttamente",
    uploadVersion: "Carica versione",
    versionUploaded: "Versione del documento caricata",
    submitReview: "Invia alla revisione legale",
    submittedForReview: "Inviato alla revisione legale",
    legalReview: "Revisione legale",
    reviewApproved: "Revisione legale approvata",
    changesRequested: "Modifiche richieste",
    reviewerName: "Nome del professionista legale qualificato",
    reviewerCapacity: "Qualifica professionale",
    reviewerRegistration: "Riferimento di iscrizione professionale",
    reviewNotes: "Note della revisione legale",
    confirmReview: "Confermo che il professionista qualificato identificato ha esaminato questa esatta versione del documento.",
    recordDecision: "Registra decisione",
    recordSignedOriginal: "Registra originale firmato",
    signatureNotes: "Note sulla firma",
    signedWarning: "Il PDF firmato sarà conservato come originale immutabile e non potrà essere sostituito.",
    selectSignedPdf: "Selezionare prima il PDF firmato",
    storeAndLock: "Conserva e blocca l’originale firmato",
    signedOriginalStored: "Originale firmato conservato e bloccato",
  },
  ru: {
    download: "Скачать",
    controlledGeneration: "Контролируемое создание документов",
    noApprovedTemplate: "Для этого типа документа и языка нет утверждённого шаблона.",
    generatePdf: "Создать PDF",
    generateDocx: "Создать DOCX",
    generated: "Документ успешно создан",
    uploadVersion: "Загрузить версию",
    versionUploaded: "Версия документа загружена",
    submitReview: "Отправить на юридическую проверку",
    submittedForReview: "Отправлено на юридическую проверку",
    legalReview: "Юридическая проверка",
    reviewApproved: "Юридическая проверка одобрена",
    changesRequested: "Запрошены изменения",
    reviewerName: "Имя квалифицированного юридического специалиста",
    reviewerCapacity: "Профессиональный статус",
    reviewerRegistration: "Регистрационный номер специалиста",
    reviewNotes: "Примечания юридической проверки",
    confirmReview: "Я подтверждаю, что указанный квалифицированный специалист проверил именно эту версию документа.",
    recordDecision: "Зафиксировать решение",
    recordSignedOriginal: "Зарегистрировать подписанный оригинал",
    signatureNotes: "Примечания к подписанию",
    signedWarning: "Подписанный PDF будет сохранён как неизменяемый оригинал и не сможет быть заменён.",
    selectSignedPdf: "Сначала выберите подписанный PDF",
    storeAndLock: "Сохранить и заблокировать подписанный оригинал",
    signedOriginalStored: "Подписанный оригинал сохранён и заблокирован",
  },
};

export default legalDocumentActionTranslations;
